@let isOpen = store.isOpenSg();
@let origin = originSg();
@let overlayHasSearch = store.overlayHasSearchSg();
@let overlayEntityName = store.overlayEntityNameSg();
@let searchTerm = store.searchTermSg();
@let count = store.countSg();
@let hasVisibleItems = store.hasVisibleItemsSg();
@let selectedItem = store.selectedItemSg();
@let filteredItems = store.filteredItemsSg();
@let virtualScrollHeight = virtualScrollHeightSg();
@let overlaySearchMinCharacters = store.overlaySearchMinCharactersSg();
@let loading = store.loadingSg();
@let error = store.errorSg();
@let overlayWidth = overlayWidthPxSg();

@if (isOpen) {
  <atn-ds-attached-overlay
    [origin]="origin"
    (backdropClick)="
      $event.stopPropagation(); store.patchState({ isOpen: false })
    "
  >
    <div
      class="ds-single-select-overlay"
      data-test-id="atn-single-select-overlay"
      [style.width.px]="overlayWidth"
    >
      @if (overlayHasSearch) {
        <div
          data-test-id="atn-single-select-overlay-search"
          class="ds-single-select-overlay__search"
        >
          <i class="atn-icon atn-search atn-blue"></i>
          <input
            data-test-id="atn-single-select-overlay-search-input"
            placeholder="Filter {{ overlayEntityName ?? 'Search' }}"
            class="ds-single-select-overlay__search-input"
            [value]="searchTerm"
            (keyup)="store.setSearchValue(searchInput.value)"
            #searchInput
          />
          @if (searchTerm.length > 0) {
            <i
              data-test-id="atn-single-select-overlay-search-clear"
              class="atn-icon atn-close atn-blue"
              (click)="store.setSearchValue('')"
            ></i>
          }
        </div>
      }

      @if (count > 0) {
        @if (hasVisibleItems) {
          <div class="ds-single-select-overlay__items">
            <div [style.height.px]="virtualScrollHeight">
              <cdk-virtual-scroll-viewport
                class="ds-single-select-overlay__items-container"
                [itemSize]="itemHeight"
                [maxBufferPx]="itemHeight * maxItems"
                [minBufferPx]="itemHeight * minItems"
              >
                <div
                  *cdkVirtualFor="let item of filteredItems"
                  class="ds-single-select-overlay__item"
                  data-test-id="atn-single-select-overlay-item"
                  [class.ds-single-select-overlay__item--selected]="
                    selectedItem === item
                  "
                  [atnDsEllipsisTooltip]="item.label"
                  (click)="selectedItem !== item && setSelectedHandler(item)"
                >
                  {{ item.label }}
                </div>
              </cdk-virtual-scroll-viewport>
            </div>
          </div>
        } @else {
          <div class="ds-single-select-overlay__no-items">
            No
            {{
              (overlayEntityName ??
              searchTerm.length > (overlaySearchMinCharacters ?? 0))
                ? 'search results'
                : 'items'
            }}
            found
          </div>
        }
      } @else if (loading) {
        <span data-test-id="atn-single-select-overlay-loading-state"
          >loading...</span
        >
      } @else {
        <div
          data-test-id="atn-single-select-overlay-empty-state"
          class="ds-single-select-overlay__empty-state"
        >
          <atn-ds-empty-state
            description="No items"
            layout="v"
            [title]="error ? error : 'No items'"
            [type]="error ? 'error' : 'no-data'"
          />
        </div>
      }
    </div>
  </atn-ds-attached-overlay>
}
